import { Selector } from 'sonata-react-components';

import './group.scss';

export function Group({
  defaultValue = [],
  groups = [],
  onChange
}: {
  defaultValue: any;
  groups: any[];
  onChange: (selectedItems: any[]) => void;
}) {
  const items = groups.map(group => ({
    id: group._id,
    label: group.name,
    tags: [
      {
        color: group.color,
        label: group.name?.slice(0, 1).toUpperCase()
      }
    ],
    value: group._id
  }));

  const defaultItems = items.filter(item => defaultValue.includes(item.id));

  const handleOnChange = (selectedItems: any[]) => {
    const selectedIds = selectedItems.map(item => item.id);
    onChange(selectedIds);
  };

  return (
    <div className="group">
      <Selector
        className="group__selector"
        defaultValue={defaultItems}
        isDisabled={!groups[0]}
        onChange={handleOnChange}
        options={items}
        optionsPlacement="bottom"
        showSearch={false}
        showSelectAll
        showSelectedItems={false}
        tiny
        type="multiple"
      />
    </div>
  );
}
